/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
3/26/2020
Tree and Replanting Container
**********************************************************/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UrlList from '../url_list';
import { TREE_URLS } from '../../cult_constants';

class TreeReplantContainer extends Component {
  render() {
    return (
      <div className="row">
        <div className="col s12 m1 l1">
          <UrlList listItems={TREE_URLS} id={'cult-url-nav'} />
        </div>
        <div className="col m11 l11">
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(TreeReplantContainer);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_replant_container.js